import React from 'react';

/**
 * TokenIcon — canonical currency glyph.
 * Green fill of the lightning-bolt SVG used at the top of concept card
 * summary thumbnails, so the in-game currency visually matches the
 * concept-card "summary" iconography.
 */
export default function TokenIcon({ size = 14, className = '', title, ...rest }) {
  return (
    <svg
      className={`token-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="#24fe9f"
      stroke="#24fe9f"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={!title}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title && <title>{title}</title>}
      <polygon points="15 1 5 14 12 14 9 23 19 10 12 10 15 1" />
    </svg>
  );
}
